export default "__VITE_ASSET__CqogXdEK__"